/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { FaTools } from "react-icons/fa";
import { crudDe } from "../../../../services/acesso";
import api from "../../../../services/api";
import { useEffect, useState } from "react";
import Listagem from "../../../../components/listagem";
import { useAppSelector } from "../../../../store/hooks";
import ModalForm from "../../../../components/modal-form";
import ModalImportacao from "../../../../components/modal-importacao";
import { ApiError, Campo, Peca } from "../../../../services/tipos";
import { LocaSmartLayout } from "../../../../components/locasmart-layout";
import { TipoFormulario, TipoVeiculo } from "../../../../services/constantes";
import { obterIdTenent, usuarioTemPermissao } from "../../../../services/seguranca";
import { useFiliais } from "../../../../hooks/useFiliais";
import { CAMPOS_PECA } from "../../../../services/importacao";

function PecaListagem() {
    const { empresaTemFiliais, filiaisOptions, getCampoFilial, getAcaoEmLoteFilial } = useFiliais();
    const [pecas, setPecas] = useState<Peca[]>([]);
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [pecaSelecionado, setPecaSelecionado] = useState<Peca>({} as Peca);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [showModalImportacao, setShowModalImportacao] = useState<boolean>(false);

    const colunas = [
        { field: 'nome', headerName: 'Nome', flex: 1 },
        { field: 'modelo', headerName: 'Modelo', flex: 1 },
        { field: 'marca', headerName: 'Marca', flex: 1 },
        { field: 'vidaUtilEmKm', headerName: 'Vida útil (km)', flex: 1 },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', flex: 1, renderCell: (params: any) => { if (!params.value) return ''; const f = filiaisOptions.find((x: any) => x.valor === params.value); return f?.label || ''; } }] : []),
    ];

    const campoFilial = getCampoFilial({ linha: 0, coluna: 1, largura: 6 });

    const campos: Campo[] = [
        ...(campoFilial ? [campoFilial] : []),
        {
            label: 'Tipo do veículo', nome: 'tipoVeiculo', required: true, tipo: 'select', largura: 6, coluna: 1, linha: 1, visible: true, opcoes: [
                { label: 'Carro', valor: TipoVeiculo.tpCarro },
                { label: 'Moto', valor: TipoVeiculo.tpMoto },
                { label: 'Ambos', valor: TipoVeiculo.tpAmbos },
            ], ajudinha: {
                texto: 'Este campo indica o tipo de veículo ao qual a peça está associada. Ele será útil para que, durante a movimentação de serviços, sejam exibidas apenas as peças compatíveis com o tipo de veículo em questão.', autoCloseTime: 3
            }
        },
        { label: 'Nome', nome: 'nome', required: true, tipo: 'text', largura: 6, coluna: 2, linha: 1, visible: true, tudoMaiusculo: true },
        { label: 'Marca', nome: 'marca', required: true, tipo: 'text', largura: 12, coluna: 1, linha: 3, visible: true, tudoMaiusculo: true },
        { label: 'Modelo/Número', nome: 'modelo', required: true, tipo: 'text', largura: 6, coluna: 1, linha: 4, visible: true, tudoMaiusculo: true },
        { label: 'Vida útil (km)', nome: 'vidaUtilEmKm', required: false, tipo: 'number', largura: 6, coluna: 2, linha: 4, visible: true,
            ajudinha: {
                texto: 'Esse campo indica a vida útil da peça. \nEle será utilizado posteriormente pela nossa inteligência artificial para identificar a necessidade de realizar a próxima manutenção. ', autoCloseTime: 3
            }
        },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 6, visible: false, tudoMaiusculo: true },
    ];

    const temPermissao = usuarioTemPermissao(token, 'peca_visualizar');

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        toast.error('Não foi possível continuar a operação peça: ' + error.response?.data.Mensagem)
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    const handleCadastrar = async () => {
        if (usuarioTemPermissao(token, 'peca_novo')) {
            setModo(TipoFormulario.tpCadastro)
            setPecaSelecionado({ vidaUtilEmKm: 0 } as Peca);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar um novo Peça')
        }
    }

    const handleEditar = async (peca: any) => {
        if (usuarioTemPermissao(token, 'peca_editar')) {
            setModo(TipoFormulario.tpEdicao)
            setPecaSelecionado(peca);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para editar uma Peça')
        }
    }

    const handleExclusao = async (peca: Peca) => {
        if (usuarioTemPermissao(token, 'peca_excluir')) {
            setCarregando(true);
            await api.delete(`/peca/${peca.id}`)
                .then(response => {
                    setTimeout(() => {
                        toast.success('Peça foi excluída com sucesso')
                        setRealizarConsulta(true)
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    tratarErro(error);
                });
        }
    }

    const handleVisualizacao = async (peca: any) => {
        if (usuarioTemPermissao(token, 'peca_visualizar')) {
            setPecaSelecionado(peca);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao)
        }
    }

    useEffect(() => {
        const fetchPecaPorEmpresa = async () => {
            if ((temPermissao) && (realizarConsulta)) {
                setCarregando(true);
                await api.get(`/pecaPorEmpresa/${obterIdTenent(token)}`)
                    .then(response => {
                        setTimeout(() => {
                            setPecas(response.data);
                            setRealizarConsulta(false);
                            setCarregando(false);
                        }, 250);
                    }).catch((error: AxiosError<ApiError>) => {
                        setCarregando(false);
                        tratarErro(error);
                    });
            }
        }

        fetchPecaPorEmpresa();
    }, [temPermissao, realizarConsulta, token]);

    const requisicaoBemSucedida = (response: any) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success('Peça salva com sucesso')
        setFezAlgumaAcao(true);
    }

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={crudDe('peca')}
                    colunas={colunas}
                    linhas={pecas}
                    nomeEntidade="Peça"
                    nomePropriedade="nome"
                    carregando={carregando}
                    IconeEntidade={FaTools}
                    exibirAcoesDeCrud={true}
                    handleEditar={handleEditar}
                    handleCriar={handleCadastrar}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setPecaSelecionado}
                    onImportar={() => setShowModalImportacao(true)}
                    acoesEmLote={[
                        ...(getAcaoEmLoteFilial('Peca', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('Peca', () => setRealizarConsulta(true))!] : []),
                    ]}
                />

                <ModalImportacao
                    show={showModalImportacao}
                    onHide={() => setShowModalImportacao(false)}
                    titulo="Importar Peças"
                    campos={CAMPOS_PECA}
                    nomeTemplate="template-pecas"
                    camposFixos={{ idEmpresa: obterIdTenent(token), dataCadastro: new Date().toISOString() }}
                    enviar={async (item) => { await api.post('/peca', item); }}
                    permitirAtualizacao
                    chaveMatch="modelo"
                    rotuloCampo="nome"
                    buscarExistentes={async () => {
                        const resp = await api.get(`/pecaPorEmpresa/${obterIdTenent(token)}`);
                        return resp.data || [];
                    }}
                    atualizar={async (item) => { await api.put('/peca', item); }}
                    onImportacaoConcluida={() => setRealizarConsulta(true)}
                />

                <ModalForm
                    modo={modo}
                    tamanho="lg"
                    campos={campos}
                    show={exibirFormModal}
                    carregando={carregando}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    ajudinha={
                        {
                            texto: "Aqui você poderá cadastrar peças que serão utilizados em movimentações, como a de manutenções. Esses cadastros facilitam a seleção nas telas de movimentação, garantindo uma escolha rápida e a padronização das operações.",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={pecaSelecionado}
                    apiConfig={
                        {
                            endpoint: "peca",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                />
            </LocaSmartLayout>
        </>
    );
}

export default PecaListagem;